
//转盘数据
export const initRotaryTable = {
  resultCode: 0,
  resultMsg:"外层网关调用结果说明",
  resultData:{
    success : true,
    code:"success",
    msg:"执行状态结果说明",
    data:[
      {
        rewardAmount:"10",
        rewardName:"京东支付",
        rewardDes:"满399可用",
        rewardBg:1
      },{
        rewardAmount:"30",
        rewardName:"京东支付",
        rewardDes:"满399可用",
        rewardBg:1
      },{
        rewardAmount:"100",
        rewardName:"京东支付",
        rewardDes:"满399可用",
        rewardBg:2
      },{
        rewardAmount:"50",
        rewardName:"京东支付",
        rewardDes:"满399可用",
        rewardBg:1
      },{
        rewardAmount:"100",
        rewardName:"京东支付",
        rewardDes:"满399可用",
        rewardBg:1
      },{
        rewardAmount:"100",
        rewardName:"京东支付",
        rewardDes:"满399可用",
        rewardBg:2
      },{
        rewardAmount:null,
        rewardName:null,
        rewardDes:null,
        rewardBg:1
      },{
        rewardAmount:"100",
        rewardName:"京东支付",
        rewardDes:"满399可用",
        rewardBg:1
      }
    ]
  }
      
}
//b端抽奖
export const bShenQLottery = {
  resultCode: 0,
  resultMsg:"外层网关调用结果说明",
  resultData:{
    data: {
      "rewardDes": "满1000可用",
      "rewardName": "京东支付",
      "rewardAmount": 10
    },
    code: "success",
    msg: "抽奖成功"
  }
}
//b端头像
export const getHeadUrlByEnBPin = {
  resultCode: 0,
  resultMsg:"外层网关调用结果说明",
  resultData:{
    data: "",
    code: "success",
    msg: "获取头像成功"
  }
}
//c端助力B端
export const cHelpBAndLottery = {
  resultCode: 0,
  resultMsg:"外层网关调用结果说明",
  resultData:{
    code: "act_ex",
    msg: "获取头像成功",
    data: {
      rewardAmount:"100",
      rewardName:"京东支付",
      rewardDes :"满199可用",
      rewardBg:"1"
    },
  }
}
//查询C端领奖页面信息
export const getToDayHitRd = {
  resultCode: 0,
  resultMsg:"外层网关调用结果说明",
  resultData:{
    code: "pick_sucess",
    msg: "获取头像成功",
    data: {
      bHeadUrl:"",
      cLastHitRdInfo:{
        joinId:"1111",
        isRecieved:"1",
        rewardAmount:"100",
        rewardName:"京东支付",
        rewardDesc :"满199可用",
        rewardBg:"1"
      }
    },
  }
}
//查询C端领奖页面信息
export const cPickupReward = {
  resultCode: 0,
  resultMsg:"外层网关调用结果说明",
  resultData:{
    code: "pick_sucess",
    msg: "领取成功",
  }
}

export const fromShareRedirect = {

}
export const getLastHitRdListAndTotal = {

}
export const getBTotalAndUsedTimes = {

}
export const encodeBpin = {

}
export const sQShareSave = {
  
}


// WEBPACK FOOTER //
// ./src/api/mock.js